import Swal from "sweetalert2/dist/sweetalert2.js";
import { Turbo } from "@hotwired/turbo-rails";

const Toast = Swal.mixin({
  toast: true,
  position: "bottom-end",
  iconColor: "white",
  customClass: {
    popup: "colored-toast"
  },
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true
});

type ToastLevel = "notice" | "alert";

function fireToast(message: string, level: ToastLevel) {
  Toast.fire({
    icon: level === "alert" ? "error" : "success",
    title: message
  });
}

function showFlashToast() {
  const flashMessage = document.body.getAttribute("data-flash-notice");
  if (flashMessage) {
    fireToast(flashMessage, "notice");
  }

  const flashAlert = document.body.getAttribute("data-flash-alert");
  if (flashAlert) {
    fireToast(flashAlert, "alert");
  }
}

document.addEventListener("DOMContentLoaded", showFlashToast);

document.addEventListener("turbo:load", showFlashToast);

Turbo.StreamActions.flash = function () {
  const message = this.templateContent.textContent?.trim();
  if (!message) return;

  fireToast(message, this.getAttribute("level") === "alert" ? "alert" : "notice");
};
